"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.knowledge.bonus': 'Knowledge added',
    'onboarding.knowledge.items': 'Knowledge Items',
    'onboarding.knowledge.base': 'Knowledge Base',
    'onboarding.knowledge.title': 'Knowledge Base',
    'onboarding.knowledge.description': 'Upload or select knowledge documents for your avatar.',
    'onboarding.knowledge.final.step': 'Final Step',
    'onboarding.knowledge.label': 'Select Knowledge',
    'onboarding.knowledge.placeholder': 'Choose knowledge documents...',
    'onboarding.knowledge.skip.info': 'You can skip this step and add knowledge later.',
    'onboarding.knowledge.selected.single': 'document selected',
    'onboarding.knowledge.selected.multiple': 'documents selected',
};
